import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { RelatorioDespesaItem, DespesaQuery } from "../typings";
import http from "infra/http";
import { PaginateResult } from "core/resources/types/shared";

export function useDespesasPaginado(query: DespesaQuery) {
  return useQuery<
    PaginateResult<RelatorioDespesaItem> & { total: number },
    AxiosError
  >(["/v1/relatorios/financeiro/despesas/paginado", query], async () => {
    const { data } = await http.get<
      PaginateResult<RelatorioDespesaItem> & { total: number }
    >("/v1/relatorios/financeiro/despesas/paginado", {
      params: query,
    });

    return data;
  });
}
